import {
  LinkedinLogo,
  PaperPlaneTilt,
  UserPlus,
  Wallet,
} from "@phosphor-icons/react";

import OnboardingProgressCircle from "common/components/OnboardingProgressCircle";
import useOnboardingProgress from "common/hooks/useOnboardingProgress";

import AddPayment from "./AddPayment";
import ConnectAccount from "./ConnectAccount";
import CreateCampaign from "./CreateCampaign";
import InviteTeamMember from "./InviteTeamMember";
import OnboardingItem from "./OnboardingItem";

export default function OnboardingProgress() {
  const {
    hasAccounts,
    hasCampaigns,
    hasPaymentSource,
    hasTeamMembers,
    isCompleted,
    isLoadingProgress,
    isLoadingCampaigns,
    isLoadingSubscriptionPaymentSource,
    completedStepsCount,
  } = useOnboardingProgress();

  return (
    <section className="border border-black-200 rounded-3xl">
      <div className="p-3 border-b border-dashed border-black-200 flex items-center gap-x-2.5">
        <OnboardingProgressCircle
          value={completedStepsCount}
          isLoading={isLoadingProgress}
        />
        <h3 className="text-md-bold">
          {isCompleted ? "You're all set up! 🎉" : "Onboarding progress"}
        </h3>
      </div>

      <OnboardingItem
        icon={LinkedinLogo}
        label="Connect account"
        description="Securely connect a LinkedIn account to get started"
        actionComponent={<ConnectAccount />}
        isCompleted={hasAccounts}
      />

      <OnboardingItem
        icon={PaperPlaneTilt}
        label="Create a campaign"
        description="Start reaching out to targeted prospects "
        isCompleted={hasCampaigns}
        isLoading={isLoadingCampaigns}
        actionComponent={<CreateCampaign />}
      />

      <OnboardingItem
        icon={UserPlus}
        label="Invite your team"
        description="Invite your teammates with fully customizable permissions"
        isCompleted={hasTeamMembers}
        actionComponent={<InviteTeamMember />}
      />

      <OnboardingItem
        icon={Wallet}
        label="Add a payment method"
        description="Ensure a smooth upgrade and avoid downtime once your trial expires"
        isCompleted={hasPaymentSource}
        isLoading={isLoadingSubscriptionPaymentSource}
        actionComponent={<AddPayment />}
      />
    </section>
  );
}
